import React from 'react';

interface QuantitySelectorProps {
  quantity: number;
  onQuantityChange: (newQuantity: number) => void;
  disabled?: boolean;
  minQuantity?: number;
  maxQuantity?: number;
  className?: string;
  buttonClassName?: string;
  inputClassName?: string;
}

export const QuantitySelector = ({
  quantity,
  onQuantityChange,
  disabled = false,
  minQuantity = 0,
  maxQuantity,
  className = '',
  buttonClassName = '',
  inputClassName = ''
}: QuantitySelectorProps) => {
  const handleDecrease = () => {
    if (!disabled && quantity > 0) {
      onQuantityChange(quantity - 1);
    }
  };

  const handleIncrease = () => {
    if ((!maxQuantity || quantity < maxQuantity) && !disabled) {
      onQuantityChange(quantity + 1);
    }
  };

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const newQuantity = Number(e.target.value);
    if (
      newQuantity >= minQuantity &&
      (!maxQuantity || newQuantity <= maxQuantity)
    ) {
      onQuantityChange(newQuantity);
    }
  };

  const isDecreaseDisabled = disabled || quantity <= 0;
  const isIncreaseDisabled = disabled || (maxQuantity && quantity >= maxQuantity);

  return (
    <div className={`quantity flex items-center border border-[#EDEDED] rounded-3xl lg:px-2 lg:py-0.5 ${className}`}>
      <button
        className={`quantity-btn p-2.5 disabled:opacity-50 disabled:cursor-not-allowed h-9 w-9 text-[#878787] ${buttonClassName}`}
        onClick={handleDecrease}
        disabled={isDecreaseDisabled}
        aria-label='Decrease quantity'
      >
        <i className='icon icon-quantity-minus font-bold'> </i>
      </button>
      <input
        type='number'
        className={`quantity-input p-2.5 appearance-none !border-none !outline-none h-9 w-9 font-bold ${inputClassName}`}
        value={quantity}
        min={minQuantity}
        max={maxQuantity}
        onChange={handleInputChange}
        disabled={disabled}
        aria-label='Quantity'
      />
      <button
        className={`quantity-btn p-2.5 disabled:opacity-50 disabled:cursor-not-allowed h-9 w-9 text-[#878787] ${buttonClassName}`}
        onClick={handleIncrease}
        disabled={isIncreaseDisabled}
        aria-label='Increase quantity'
      >
        <i className='icon icon-quantity-plus font-bold'> </i>
      </button>
    </div>
  );
};
